export default "__VITE_ASSET__BfD6quih__"